<div class="loader" [ngStyle]="{'min-height.px': minHeight}">
  <div class="logo_loader_container">
    <div class="pos_rel_container">
      <span class="mylead-logo"></span>
      <div id="loader-wrapper" class="new_loader_spinner">
        <div id="loader"></div>
      </div>
    </div>
  </div>
</div>
